export const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)');
const shouldAnimate = () => !reducedMotionQuery.matches;
export default shouldAnimate;
